import { get } from "./api"

// Per-visitor values fetched from an uncacheable endpoint, because the CDN may serve
// the HTML to someone else. `sso`/`connect` are opt-in: each writes to the session.
const promises = {}

export default function fetchSessionContext({ sso = false, connect = false } = {}) {
  const key = `${sso}:${connect}`

  if (!promises[key]) {
    const params = [`gf=${new Date().getTime()}`]
    if (sso) params.push("sso=1")
    if (connect) params.push("connect=1")

    // Don't cache a rejection — later callers need to be able to retry.
    promises[key] = get(`/session_context.json?${params.join("&")}`).catch(error => {
      delete promises[key]
      throw error
    })
  }

  return promises[key]
}
